import 'shared-react/lumen/styles.css';

import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import {
  PrismComboSelectInput,
  PrismIcon,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-logo';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils';
import GeneralHeaderLogo from 'lumen/components/general/header-logo';
import HotelAndMarketDropdownsHotelSelectionDropdown from 'lumen/components/hotel-and-market/dropdowns/hotel-selection-dropdown';
import HotelAndMarketDropdownsHotelSelectionDropdownOld from 'lumen/components/hotel-and-market/dropdowns/hotel-selection-dropdown-old';
import HotelAndMarketDropdownsTriggersAccountTrigger from 'lumen/components/hotel-and-market/dropdowns/triggers/account-trigger';
import HotelAndMarketNavigationNavigationMain from 'lumen/components/hotel-and-market/navigation/navigation-main';
import type DestinationController from 'lumen/controllers/destination';
import hasFeatureToggle from 'lumen/helpers/has-feature-toggle';
import mountReact from 'lumen/modifiers/mount-react';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import { DaasHeader } from 'shared-react/lumen';

interface DestinationSignature {
  Args: {
    controller: DestinationController;
    model: unknown;
  };
}

<template>
  {{#if (hasFeatureToggle FEATURE_TOGGLES.REACT_HEADER)}}
    <div {{mountReact DaasHeader}}></div>
  {{else}}
    {{! template-lint-disable require-presentational-children }}
    <header class="header">
      <div class="content-wrapper flex justify-between">
        <div class="logo-and-rebranding-container">
          {{#if @controller.model.whiteLabel}}
            <GeneralHeaderLogo @reseller={{@controller.model.whiteLabel}} />
          {{else}}
            <a class="flex items-center" href={{@controller.ajax.host}}>
              <Illustration
                @html={{ICONS_LOGOS_MAP.logo-color}}
                class="platform-logo"
              />
            </a>
          {{/if}}
        </div>

        <HotelAndMarketNavigationNavigationMain />

        <div
          class="header-user-actions-container flex items-center justify-end"
        >
          <div
            class="flex items-center justify-center"
            data-event-id="hotel-or-market-search-dropdown"
            id="hotel-selecter-container"
          >
            {{#if (hasFeatureToggle FEATURE_TOGGLES.UNIFIED_HOTEL_VIEW)}}
              <HotelAndMarketDropdownsHotelSelectionDropdown
                @isDemoMode={{@controller.isDemoMode}}
              />
            {{else}}
              <HotelAndMarketDropdownsHotelSelectionDropdownOld
                @isDemoMode={{@controller.isDemoMode}}
              />
            {{/if}}
          </div>
          <div
            class="settings-button flex items-center justify-center
              {{if @controller.isSettingsButtonActive 'active'}}"
            data-event-id="settings-button"
            data-test-id="settings-button"
            role="button"
            {{! @glint-expect-error: Incorrect type }}
            type="button"
            {{on "click" @controller.redirectToSettings}}
          >
            <PrismIcon @color="inherit" @name="settings" @size="large" />
          </div>
          <div class="account-button flex items-center justify-center">
            <PrismComboSelectInput
              @horizontalPosition="right"
              @onChange={{@controller.dummy}}
              @onClose={{@controller.toggleActive}}
              @onOpen={{@controller.toggleActive}}
              @options={{@controller.settingsOptions}}
              @unsafe_dropdownClass="account-button-dropdown"
              @unsafe_triggerComponent={{HotelAndMarketDropdownsTriggersAccountTrigger}}
              @value={{null}}
              data-test-id="account-dropdown"
            />
          </div>
        </div>
      </div>
    </header>
  {{/if}}

  {{#if @controller.showEmptyState}}
    <div class="mt-800 flex justify-center">
      <PrismMessage
        @illustration="100x100_critical"
        @title={{t "general.permission_denied"}}
      />
    </div>
  {{else}}
    <div class="main-content bg-main-content" id="content-container">
      {{outlet}}
    </div>
  {{/if}}
</template> satisfies TOC<DestinationSignature>;
